import { useMemo } from 'react'
import { getUniqueOrders, useSelectionContext } from 'providers/SelectionProvider'
import type { Order } from 'types'

type UseSelectedLocationsResult = {
  uniqueOrders: Order[]
  selectedLocationIds: string[]
  isSingleLocation: boolean
  currentLocationId: string | undefined
}

const useSelectedLocations = (): UseSelectedLocationsResult => {
  const { selections } = useSelectionContext()

  return useMemo(() => {
    const uniqueOrders = getUniqueOrders(selections)
    const selectedLocationIds = [...new Set(uniqueOrders.map(o => o.locationId).filter((id): id is string => !!id))]
    const isSingleLocation = selectedLocationIds.length === 1
    const currentLocationId = isSingleLocation ? selectedLocationIds[0] : undefined

    return { uniqueOrders, selectedLocationIds, isSingleLocation, currentLocationId }
  }, [selections])
}

export default useSelectedLocations
